import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {translate} from 'views/module';

import ClientPaymentStatusData from './data/ClientPaymentStatusData';
import WidgetHeader from '../utils/WidgetHeader';
import SmallSkeleton from '../utils/skeleton/SmallSkeleton';

const ClientPaymentStatus = (props) => {
  const {
    editMode,
    dashboardSettings,
    removeWidget,
    statusProgressWrap,
  } = props;

  const groupRn = dashboardSettings.detail.group?.groupRn || null;

  if (dashboardSettings.type === 'TEAM' && !groupRn) return null;

  return (
    <>
      <WidgetHeader
        title={translate('dashboardWidgets.ClientPaymentStatus.Title')}
        editMode={editMode}
        removeWidget={removeWidget}
      />
      <Box sx={{height: '400px', overflowY: 'auto', scrollbarWidth: 'thin', py: 1, pr: 1, mr: -1}}>
        {
          editMode ?
          <SmallSkeleton />:
          <ClientPaymentStatusData
            statusProgressWrap={statusProgressWrap}
          />
        }
      </Box>
    </>
  );
};

ClientPaymentStatus.propTypes = {
  editMode: PropTypes.bool.isRequired,
  removeWidget: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func,
  dashboardSettings: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(ClientPaymentStatus);
